<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>添加活动</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图 -->
    <el-card>
      <!-- 提示区域 -->
      <el-alert title="添加活动信息" type="info" center show-icon :closable="false"> </el-alert>
      <!-- 步骤条区域 -->
      <el-steps :space="200" :active="activeIndex - 0" finish-status="success" align-center>
        <el-step title="基本信息"></el-step>
        <el-step title="选择商品"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>

      <!-- tab栏区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px" label-position="top">
        <el-tabs v-model="activeIndex" :tab-position="'left'" :before-leave="beforeTabLeave" @tab-click="tabClicked">
          <el-tab-pane label="基本信息" name="0">
            <el-form-item label="活动名称" prop="name" style="width: 200px">
              <el-input v-model="addForm.name" placeholder="例如：满5件赠送1件"></el-input>
            </el-form-item>
            <el-form-item label="活动内容" prop="content">
              满 <el-input style="width: 50px" v-model="addForm.max"></el-input>件 赠送 <el-input style="width: 50px" v-model="addForm.send"></el-input>件
            </el-form-item>
            <el-form-item label="活动结束时间" prop="endTime">
              <el-date-picker v-model="addForm.endTime" type="datetime" placeholder="选择结束时间" :picker-options="pickerOptions"> </el-date-picker>
            </el-form-item>

            <el-form-item label="经销商可享受次数" prop="userSharedCount" style="width: 400px">
              <!-- <el-select v-model="addForm.userSharedCount" @change="handleCommissioer" placeholder="请选择">
                <el-option v-for="item in userSharedCountlist" :key="item" :label="item" :value="item"> </el-option>
              </el-select> -->
              <el-input v-model="addForm.userSharedCount" placeholder="可享受的次数，不输入代表不限制次数"></el-input>
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="选择商品" name="1">
             <!-- @clear="getUserList" -->
            <el-select v-model="addForm.goodsInfoas"  filterable  style="width: 400px" placeholder="请选择">
              <el-option
                v-for="item in tableData"
                :key="item.id"
                :label="item.number+'~'+item.title"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary"  class="btnAdd" @click="handleSelectionChange(addForm.goodsInfoas)">添加</el-button>
            <!-- <el-button type="primary"  class="btnAdd" @click="editSave"></el-button> -->
            <el-table
              :data="tableDatasa"
              style="width: 100%">
              <el-table-column
                prop="id"
                label="ID"
                width="180">
              </el-table-column>
              <el-table-column
                prop="number"
                label="编号"
                width="180">
              </el-table-column>
              <el-table-column
                prop="title"
                label="标题">
              </el-table-column>
              <el-table-column label="操作" >
                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleSelectionChangesa(scope.row.id)" ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" v-if="addForm.id == 0" class="btnAdd" @click="add">保存活动</el-button>
            <el-button type="primary" v-if="addForm.id > 0" class="btnAdd" @click="editSave">保存</el-button>
            

            <!-- <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" border stripe>
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column label="商品名称" width="180" prop="title"></el-table-column>
              <el-table-column label="商品编号" prop="number"> </el-table-column>
            </el-table> -->
           

            <!-- 分页区域 -->
            <!-- <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfo.pagenum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="queryInfo.pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination> -->

            <!-- 添加商品的按钮 -->
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </el-card>
  </div>
</template>

<script>


import _ from 'lodash'

export default {
  data () {

    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      value1:[],
      queryInfo: {
        pagenum: 1,
        pagesize: 10
      },
      tableData: [{ a_userSharedCount: 0 }],
      readyTableData: [],
      //已选择的经销商列表
      selectUserList: [],
      multipleSelection: [],
      // userSharedCountlist: [
      //   1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
      //   20, 30, 50, 100, 500
      // ],
      total: 0,
      activeIndex: 0,
      // 添加商品的表单数据对象
      addForm: {
        id: 0,
        name: '',
        max: null,
        send: null,
        endTime: null,
        userSharedCount: null,
        goodsInfo: [],
        goodsInfoas: '',
        oldGoodsInfo: [],
      },
      tableDatasa: [],
      addFormRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        max: [
          { required: true, message: '请输入满多少送', trigger: 'blur' }
        ],
        send: [
          { required: true, message: '请输入送多少', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请输入结束时间', trigger: 'blur' }
        ]
      },
    }
  },

  created () {
    // console.log(this.$route.query.id);
    if (this.$route.query.id > 0) {//编辑
      this.addForm.id = this.$route.query.id;
      this.getDetail(this.$route.query.id);
    }
    this.getUserList();
  },

  methods: {

    inputchange (e) {
      console.log('inputchange' + e)
    },

    onExchangeChange: function (index) {
      let tmpObj = this.tableData[index];
      this.$set(this.tableData, index, tmpObj);
    },

    change: function (index) {
      // 重新赋值
      let tmpObj = this.tableData[index];
      this.$set(this.tableData, index, tmpObj);
    },

    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },

    // 监听 页码值 改变的事件
    handleCurrentChange (newPage) {
      console.log(newPage)
      this.queryInfo.pagenum = newPage
      this.getUserList()
    },

    // 勾选商品
    handleSelectionChange (val) {
      var list = [];
      var ifid ='';
      this.tableData.forEach(element => {
        //console.log('循环',element.id)
        if(val === element.id){
          this.tableDatasa.forEach(iftab=>{
            if(val === iftab.id){
              ifid=1
            }
          })
          if(ifid){
            return this.$message.error('数据已存在！')
          }else{
            this.tableDatasa.push({'id':element.id,'title':element.title,'number':element.number});
            this.addForm.goodsInfoas = ''
            this.addForm.goodsInfo.push(val)
            console.log(this.addForm.goodsInfo,'添加数组')
          }  
        }
      });
    },
    // 删除商品
    handleSelectionChangesa (val) {
      var list = [];
      var listas = [];
      this.tableDatasa.forEach(element => {
        //console.log('循环',element.id)
        if(val !== element.id){
          list.push({'id':element.id,'title':element.title,'number':element.number});
        }
      });
      this.addForm.goodsInfo.forEach(value => {
            if(value != val){
              listas.push(value)
            }
          })
      this.tableDatasa = list
      this.addForm.goodsInfo=listas
      console.log(this.addForm.goodsInfo,'添加数组1')
    },

    // 改为获取商品
    async getUserList () {
      // const { data: res } = await this.$http.get('admin/users/getAllUsersInUse', {
      //   params: this.queryInfo
      // })
      // if (res.code !== 200) {
      //   return this.$message.error('获取经销商数据失败！')
      // }
      // const { data: res } = await this.$http.get('admin/good/list', {
      const { data: res } = await this.$http.get('admin/activity/allGoodlist'
        // {
        //   params: this.queryInfo
        // }
      )
      if (res.code !== 200) {
        return;//this.$message.error('获取商品列表失败！')
      }
      this.tableData = res.result
      // console.log(this.tableData,'666666666666666666666666666666');
      // this.total = res.result.count
      if (this.$route.query.id > 0) {//编辑
        this.getGoodListByActivityId(this.$route.query.id)
      }
    },
    //删除选中
    async del(){
      console.log(122)
      this.addForm.goodsInfo = []
    },

    // 获取详情
    async getDetail (id) {
      const { data: res } = await this.$http.post('admin/activity/getById', {
        params: {
          id: id
        }
      })
      if (res.code !== 200) {
        return this.$message.error('获取数据失败！')
      }
      for (const key in res.result) {
        this.addForm[key] = res.result[key]
      }
    },

    // 获取此活动的商品
    async getGoodListByActivityId (id) {
      const { data: res } = await this.$http.post('admin/activity/getGoodsListByActivityId', {
        params: {
          id: id
        }
      })
      if (res.code !== 200) {
        return this.$message.error('获取数据失败！')
      }
      this.tableDatasa = res.result
      var list = [];
      res.result.forEach(row => {
        this.addForm.goodsInfo.push(row.id)
        // var that = this;
        // this.tableData.forEach(function (item, index) {
        //   if (row['id'] === item['id']) {
        //     list.push(item['id']);
        //     // that.$refs.multipleTable.toggleRowSelection(item);
        //     // that.tableData[index]['a_userSharedCount'] = row['a_userSharedCount']
        //   }
        // });
      });
      // this.addForm.oldGoodsInfo = list
      console.log(this.addForm.goodsInfo,'编辑数据');
      // this.addForm.goodsInfo = list
    },


    beforeTabLeave (activeName, oldActiveName) {
      if (oldActiveName === '0' && this.addForm.name.length == 0) {
        this.$message.error('请输入名称')
        return false
      } else if (oldActiveName === '0' && this.addForm.max == null) {
        this.$message.error('请选择满赠数')
        return false
      } else if (oldActiveName === '0' && this.addForm.endTime == null) {
        this.$message.error('请选择活动结束时间')
        return false
      }
    },

    async tabClicked () {
      console.log(this.activeIndex)
    },

    // 添加
    add () {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) {
          return this.$message.error('请填写必要的表单项！')
        }
        if (this.addForm.goodsInfo.length == 0) {
          return this.$message.error('请选择商品')
        }
        // lodash   cloneDeep(obj)
        const form = _.cloneDeep(this.addForm)
        // console.log(form,'66666666666666666777777777777')
        // 发起请求添加商品
        // 商品的名称，必须是唯一的
        const { data: res } = await this.$http.post('admin/activity/add', form)
        if (res.code !== 200) {
          return this.$message.error('添加失败！')
        }
        this.$message.success('添加成功！')
        this.$router.push('/activityList')
      })
    },

    //编辑保存
    async editSave () {
      if (this.addForm.goodsInfo.length == 0) {
        return this.$message.error('请选择商品')
      }
      // 发起请求添加商品
      // 商品的名称，必须是唯一的
      const form = _.cloneDeep(this.addForm)
      const { data: res } = await this.$http.post('admin/activity/edit', form)

      if (res.code !== 200) {
        return this.$message.error('修改失败！')
      }
      this.$message.success('修改成功！')
      this.$router.push('/activityList')
    },
  },
  computed: {

  },
}
</script>

<style lang="less" scoped>
.btnAdd {
  margin-top: 15px;
}
</style>
